import React, { useContext } from 'react';
import { TableCell } from '@material-ui/core';
import classNames from 'classnames';

import RacingDetailContext from '../../../Context/RacingDetail.context';
import shirt from 'src/assets/images/shirt.png';

interface StartNoCellProps {
  startNo: string,
  showShirt: boolean,
  scratched?: boolean
}

export default function StartNoCell({ startNo, showShirt, scratched = false }: StartNoCellProps) {
  const { hideDetail } = useContext(RacingDetailContext);

  return (
    <TableCell style={ { width: '35px' } }>
      <div className="competitors-table__number-container">
        <div className={
          classNames('competitors-table__number', {
            'competitors-table__number--no-detail': hideDetail,
            'competitors-table__number--scratched': scratched
          })
        }
        >
          { startNo }
        </div>
        {
          showShirt && !hideDetail && (
            <img
              className={
                classNames({
                  'competitors-table__shirt': true,
                  'competitors-table__shirt--hide': scratched
                })
              }
              src={ shirt }
            />
          )
        }
      </div>
    </TableCell>
  );
}
